<template>
	<div>
		<p>
			<a href="#" @click.prevent="modalActive = true">Generate New FTP Account</a> or Manually Fill Out Details Below to Use Existing.<br/>
			<small>(FTP information is provided by Randall-Reilly, not by the client or EBE.)</small>
		</p>

		<modal-overlay
			:active="modalActive"
			header="Generate FTP Account"
			@cancel="modalActive = false"
			@confirm="generateFTPAccount"
		>
			<label>Client <small>(used to generate ftp username)</small></label>
			<client-search :search-url="$store.state.sendToDetails.urls.searchUrl" @input="client = $event"/>
			<span class="loader" v-if="saving"><i class="fa fa-spinner fa-spin"></i></span>
		</modal-overlay>
	</div>
</template>

<script>
  import ClientSearch from './form-ui/ClientSearch';

  export default {
    name: 'EbeGenerateFtp',
    components: {ClientSearch},
    data() {
      return {
        client: false,
        modalActive: false,
        saving: false,
      }
    },
    methods:{
      generateFTPAccount() {
        this.saving = true;

        this.$store.dispatch('sendToDetails/generateFtp', this.client.ClientName).then(() => {
          this.saving = false;
          this.modalActive = false;
        });
      }
    }
  }
</script>

<style scoped>
  p {
    margin:10px 0;
  }

  .loader {
    position: absolute;
    bottom: -50px;
  }
</style>
